export default {
  bmiCalculator: {
    actions: {
      calculateBMI: 'Bereken BMI',
      continue: 'Doorgaan',
    },
    breadcrumbLink: 'Terug',
    coveredTreatments: {
      CON_PC_B_VERK: 'borstverkleining',
      CON_PC_G_BOL: 'bovenooglidcorrectie',
      CON_PC_L_BUIKW: 'buikwandcorrectie',
    },
    header: 'We hebben meer informatie nodig',
    insuranceNotice:
      'Een {{treatment}} laten uitvoeren op basis van een medische indicatie? Maak eerst een afspraak bij je huisarts om een verwijzing te krijgen',
    subheader:
      'Om een afspraak te maken, moeten we jouw Body Mass Index (BMI) berekenen. Vul alstublieft het volgende in:',
  },
  bmiHigh: {
    actions: {
      callUs: 'Bel ons',
    },
    availableHours: {
      friday: 'Vrijdag 8:00–17:00',
      mondayToThursday: 'Maandag–Donderdag 8:00–18:00',
      title: 'Beschikbare uren',
    },
    breadcrumbLink: 'Terug',
    contactInfo: 'Bel ons Informatiecentrum via',
    header: 'We kunnen je afspraak op dit moment nog niet inplannen.',
    partnerInfo:
      'Via onze partner kun je begeleiding krijgen om op een gezonde en haalbare manier naar een passend BMI toe te werken. Wil je samen met ons kijken wat mogelijk is? Of wil je meteen een verwijzing?',
    specialistInfo: 'We denken graag met je mee.',
    thresholdInfo:
      'Omdat je BMI boven de {{bmiThreshold}} is, kunnen we nu nog geen eerste consult voor je plannen. We helpen je natuurlijk wel graag verder.',
    yourBmi: 'Jouw BMI is ',
  },
  confirmBooking: {
    actions: {
      changeAppointment: 'Afspraak wijzigen',
      confirmBooking: 'Doorgaan',
    },
    breadcrumbLink: 'Kies datum en tijd',
    caption:
      'Let op: Aan een consult zijn € 30 (huid) of € 50,- (injectables en plastische chirurgie) consultkosten verbonden. Deze worden in mindering gebracht op de uiteindelijke prijs van je behandeling, wanneer je deze binnen een jaar ondergaat.',
    header: 'Bevestig details',
    selectDifferentTimeslot: 'Kies een ander tijdstip',
  },
  errorScreen: {
    messages: {
      canNotAcceptPatientsUnder18:
        'Velthuis Kliniek accepteert geen patiënten jonger dan 18 jaar voor de meeste behandelingen. Neem contact met ons op via 088-7785201 als je vragen hebt.',
      network: 'Netwerkfout. Check je verbinding en probeer het opnieuw.',
    },
  },
  healthWarning: {
    acknowledgementLabel:
      'Ik begrijp dat mijn gezondheidssituatie invloed kan hebben op het behandeladvies van de arts.',
    actions: {
      continue: 'Doorgaan',
    },
    breadcrumbLink: 'Terug',
    conditions: {
      epilepsy: 'epilepsie',
      heartProblems: 'hartproblemen',
      lungProblems: 'longproblemen',
      neurologicalIssues: 'neurologische klachten (hersenen)',
      smoking: 'of rook je?',
    },
    description:
      'Dan ben je ook van harte welkom voor een consult. Onze arts bekijkt tijdens het gesprek zorgvuldig wat voor jou de meest geschikte en veilige behandelroute is. Het is mogelijk dat er op basis van je gezondheidssituatie een aangepast behandeltraject wordt geadviseerd.',
    header: 'Heb je het afgelopen jaar last gehad van:',
    subheader: 'Gezondheidsgegevens',
  },
  maintenance: {
    subtitle: 'Excuses voor het ongemak.',
    title:
      'Op dit moment kun je online geen afspraak inplannen vanwege onderhoud. <0>Via deze link</0> kun je jouw gegevens achterlaten en bellen we je terug.',
  },
  patientDetails: {
    actions: {
      continue: 'Doorgaan',
    },
    description: 'Vul de volgende gegevens in om jouw afspraak te bevestigen',
    header: 'Vul jouw gegevens in',
  },
  proposedAppointment: {
    actions: {
      confirmAppointment: 'Doorgaan',
      selectTimeSlot: 'Kies een andere tijd',
    },
    description:
      'Als de volgende voorgestelde afspraak niet uitkomt, kies dan een andere tijd.',
    error:
      'Er is een fout opgetreden bij het ophalen van de beschikbare tijden.',
    header: 'Voorgestelde afspraak',
  },
  selectAppointment: {
    actions: {
      continue: 'Doorgaan',
    },
    appointmentType: 'Afspraaktype',
    breadcrumbLink: 'Kies categorie',
    header: 'Welke afspraak wil je maken?',
  },
  selectCategory: {
    actions: {
      continue: 'Doorgaan',
    },
    canNotAcceptPatientsUnder18:
      'Velthuis Kliniek accepteert geen patiënten jonger dan 18 jaar voor de meeste behandelingen. Neem contact met ons op via 088-7785201 als je vragen hebt.',
    fillDate: 'Vul je geboortedatum in',
    header: 'Kies categorie',
    learnMoreAboutDateOfBirth:
      'Lees <0>hier</0> waarom we je geboortedatum vragen',
    parentalConsentCheckbox:
      'Ik bevestig dat ik toestemming heb van mijn ouders of voogd',
    subheader: 'Waarvoor wil je een afspraak inplannen?',
  },
  selectClinic: {
    actions: {
      selectTimeSlot: 'Kies tijd',
    },
    breadcrumbLink: 'Terug',
    firstAvailability: 'Eerst beschikbaar: {{date}}',
    header: 'Kies kliniek',
    selectDoctor: 'Kies een behandelaar',
    sortLabel: 'Sorteren',
    sortOptions: {
      alphabetical: 'Alfabetisch',
      availability: 'Op beschikbaarheid',
    },
    subheader: 'Zoek klinieken',
  },
  selectDateTime: {
    actions: {
      reviewBooking: 'Boeking controleren',
      showAllClinicianSlots: 'Toon alle tijdsloten voor zorgverleners',
    },
    breadcrumbLink: 'Selecteer arts',
    description:
      'De beschikbaarheid van tijdsloten wordt in realtime bijgewerkt en wordt na selectie bevestigd.',
    dropdownDoctors: {
      all: 'Toon alles',
      label: 'Kies een arts',
    },
    header: 'Kies datum en tijd',
    noSlots: 'Geen beschikbare tijdsloten voor de geselecteerde locatie',
  },
  selectDoctor: {
    actions: {
      continue: 'Doorgaan',
      selectAnotherLocation: 'Kies een andere locatie',
      skipThisStep: 'Sla deze stap over',
    },
    breadcrumbLink: 'Kies kliniek',
    header: 'Kies een behandelaar',
    noDoctorsFound:
      'Geen beschikbare zorgverleners voor de geselecteerde locatie. Probeer een andere locatie',
  },
}
